export const NOTIFICATION_NS = 'notification';
